module.exports = __webpack_public_path__ + "static/media/icono_docentes.3c25cd1e.svg";